import { Popover, Tag } from "antd";
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_FORCE_SYNC } from "@assets/svgs/ICON_FORCE_SYNC.svg";
import { ReactComponent as ICON_LINK } from "@assets/svgs/ICON_LINK.svg";
import { ReactComponent as ICON_MEDIA_INFO } from "@assets/svgs/ICON_MEDIA_INFO.svg";
import { ReactComponent as ICON_RESTART } from "@assets/svgs/ICON_RESTART.svg";
import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { ReactComponent as ICON_TABLE_EDIT } from "@assets/svgs/ICON_TABLE_EDIT.svg";
import { Icon } from "@components/Icon";
import { ContentInfo } from "@pages/DeviceGroupListPage/ContentInfo";
import { COLOR_DARK_GREY } from "@static/COLORS";
import {
  KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_DELETE,
  KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_UPDATE,
} from "@static/PERMISSION_KEY";

const SectionTableAction = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BASE_DEVICE_GROUP_LIST_TABLE_COLUMNS = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    fixed: "left",
    width: 80,
    sorter: (a, b) => a.index - b.index,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    fixed: "left",
    width: 280,
  },
  {
    title: "Device Master",
    dataIndex: ["deviceMaster", "name"],
    key: "deviceMaster",
  },
  // {
  //   title: "Type",
  //   dataIndex: "type",
  //   key: "type",
  //   width: 100,
  //   align: "center",
  //   render: (text, item) => {
  //     const type = _.get(item, ["type"]);
  //     let color;
  //     switch (type) {
  //       case "SYNCHRONIZED":
  //         color = "success";
  //         break;
  //       case "SEQUENTIAL":
  //         color = "error";
  //         break;
  //       default:
  //         color = "default";
  //     }
  //     return <Tag color={color}>{type}</Tag>;
  //   },
  // },
  {
    title: "Details",
    key: "details",
    align: "center",
    width: 120,

    render: (text, item, index) => {
      return (
        <Popover
          content={<ContentInfo key={index} data={item} />}
          title="Details"
          trigger="click"
        >
          <ICON_MEDIA_INFO
            style={{ cursor: "pointer" }}
            fill={COLOR_DARK_GREY}
            width={"20px"}
            height={"20px"}
          />
        </Popover>
      );
    },
  },
];

export const getDeviceGroupTableColumns = ({
  permission,
  onHandleEdit,
  onHandleDelete,
  showConfirmation,
  onHandleSoftSycGroup,
  onHandleForceSycGroup,
  // onHandleLinkDevices,
}) => {
  const deviceListColumns = [...BASE_DEVICE_GROUP_LIST_TABLE_COLUMNS];

  return [
    ...deviceListColumns,
    {
      title: "Actions",
      key: "actions",
      width: 120,

      render: (text, item, index) => {
        const isDisabled = _.chain(item)
          .get(["deviceGroupsDetails"])
          .some((detail) => {
            return _.get(detail, ["device", "is_online"]);
          })
          .value();

        return (
          <SectionTableAction key={index}>
            {/* onHandleLinkDevices */}

            {/* <Popover placement="top" trigger="hover" content={<div>Link</div>}>
              <ICON_LINK
                width={12}
                height={12}
                onClick={() => onHandleLinkDevices({ item })}
              />
            </Popover> */}
            {_.includes(
              permission,
              KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_UPDATE
            ) && (
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Edit</div>}
              >
                <ICON_TABLE_EDIT
                  width={24}
                  height={24}
                  onClick={() => onHandleEdit({ item })}
                />
              </Popover>
            )}
            {_.includes(
              permission,
              KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_DELETE
            ) && (
              // <Icon
              //   isCursor
              //   width={24}
              //   height={24}
              // onClick={() =>
              //   showConfirmation({
              //     onConfirm: () => onHandleDelete({ item }),
              //   })
              // }
              // >
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Delete</div>}
              >
                <ICON_TABLE_DELETE
                  className={isDisabled ? "icon-disabled" : "icon-clickable"}
                  width={24}
                  height={24}
                  onClick={() =>
                    showConfirmation({
                      title: "Delete",
                      onConfirm: () => onHandleDelete({ item }),
                    })
                  }
                />
              </Popover>
              // </Icon>
            )}

            {_.includes(
              permission,
              KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_UPDATE
            ) && (
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Soft Sync</div>}
              >
                <ICON_RESTART
                  // onClick={() => onHandleSoftSycGroup({ item })}
                  onClick={() =>
                    showConfirmation({
                      title: "Soft Sync",
                      onConfirm: () => onHandleSoftSycGroup({ item }),
                    })
                  }
                />
              </Popover>
            )}

            {_.includes(
              permission,
              KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_UPDATE
            ) && (
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Force Sync</div>}
              >
                <ICON_FORCE_SYNC
                  onClick={() =>
                    showConfirmation({
                      title: "Force Sync",
                      onConfirm: () => onHandleForceSycGroup({ item }),
                    })
                  }
                />
              </Popover>
            )}
          </SectionTableAction>
        );
      },
    },
  ];
};
